import axios, { AxiosError } from "axios";
import { useQuery, UseQueryOptions } from "react-query";

import { getAppConfigSetting } from "../utils/getAppConfigSetting";
import { GET_EVENT_NAMES_API } from "./constants";
import queryKeys from "./queryKeys";

export type EventNames = string[];

export function useGetEventNames(options?: UseQueryOptions<EventNames, any>) {
  const getEventNamesApi = `${getAppConfigSetting(
    "apiUrl"
  )}${GET_EVENT_NAMES_API}`;

  const getEventNames = async () => {
    const { data } = await axios.get(getEventNamesApi, {
      withCredentials: true,
    });
    return data;
  };

  return useQuery<EventNames, AxiosError>(
    [queryKeys.getEventNames],
    getEventNames,
    {
      cacheTime: 60 * 60 * 1000 * 24, // 24hrs
      staleTime: 60 * 60 * 1000 * 24, // 24hrs
      ...options,
    }
  );
}
